var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var CheckSvg = /* @__PURE__ */ __name(function CheckSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87 87"
  }, /* @__PURE__ */ React.createElement("polygon", {
    points: "34.02 62.06 23.08 51.74 24.58 50.14 33.85 58.87 62.33 25.53 64 26.95 34.02 62.06"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M43.5,2.88a41,41,0,1,1-41,41,41,41,0,0,1,41-41m0-2a43,43,0,1,0,43,43,43,43,0,0,0-43-43Z"
  }));
}, "CheckSvg");
var CheckCircleIcon = /* @__PURE__ */ __name(function CheckCircleIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: CheckSvg
  }, props));
}, "CheckCircleIcon");
export {
  CheckCircleIcon
};
